/**
 * AnonymizeEmployeeModal — F12.M Etap D Part 2 (extracted z Employees.tsx).
 *
 * RODO art. 17 — anonimizacja PII (PESEL/dowód/nazwisko zostają zaszyfrowane jako
 * placeholdery). Shell rekordu (jako referencja do historycznych umów/faktur)
 * zostaje. Endpoint: POST /api/employees/:id/anonymize.
 *
 * Permission: backend wymaga `hr.employees.anonymize`. Frontend nie gate'uje
 * widoczności guzika — backend i tak zwróci 403.
 */

import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';
import { Modal } from '@/components/Modal';

interface Props {
  /** Imię + nazwisko do pokazania w treści potwierdzenia. */
  name: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function AnonymizeEmployeeModal({ name, loading, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      open
      onClose={onClose}
      size="md"
      title={t('tenant.employees.anonymizeModal.title')}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={loading}
            data-testid="employee-anonymize-confirm"
          >
            {t('tenant.employees.anonymizeModal.confirm')}
          </Button>
        </div>
      }
    >
      <p className="mb-3 text-sm">{t('tenant.employees.anonymizeModal.body', { name })}</p>
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-300">
        {t('tenant.employees.anonymizeModal.warning')}
      </div>
    </Modal>
  );
}
